<template>
  <div>
    <div class="header2">
      <van-nav-bar
        title="分享"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>
    <div class="content-sty">
      <div class="title-sty">
        <div class="sty-tit">{{titleData}}</div>
        <van-button plain round type="info" @click.prevent="checkQu">查看问卷</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      typeId:this.$route.query.typeId,
      titleData:'',
    };
  },
  mounted(){
    this.findQaType()
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    checkQu(){
        this.$router.push({path: '/previewQuestionnaire/details', query: {typeId: this.typeId, flag: 1}});
    },
    findQaType(){
      this.$fetchGet(URL.findQaType.url, {"id": this.typeId}).then(res => {
        if (res.data.code == 20000) {
           this.titleData = res.data.data.title
        }
      })
    }

  },
};
</script>
<style scoped>
.content-sty {
  width: 95%;
  margin: 10px auto;
}
.title-sty {
  /* width: 95%;
  margin: 10px auto; */
  border-radius: 5px;
  padding: 10px;
  background: linear-gradient(178deg, rgba(79, 86, 123, 0.08), #fff);
}
.sty-tit {
  font-size: 24px;
  color: #0707a1;
}

</style>
